import { useContext } from 'react';
import CreditContext from '../contexts/creditProvider/creditContext';

const useCredit = () => {
const { creditBalance, setCreditBalance, refreshCreditBalance } = useContext(CreditContext);

return { creditBalance, setCreditBalance, refreshCreditBalance };
};

export default useCredit;